const menuItems = [
    {
        id: 1,
        label: 'menuitems.pages.list.practiceteam',
        icon: ' ri-team-line',
        link: '/pages/practice-team'
    },
    {
        id: 2,
        label: 'menuitems.pages.list.openinghours',
        icon: 'ri-history-line',
        link: '/pages/opening-hours'
    },
    {
        id: 3,
        label: 'menuitems.pages.list.openinghourspage',
        icon: 'ri-file-chart-2-line',
        link: '/pages/opening-hours-page'
    },
    {
        id: 4,
        label: 'menuitems.pages.list.news',
        icon: 'ri-article-line',
        link: '/pages/news'
    },
    {
        id: 5,
        label: 'menuitems.pages.list.alerts',
        icon: 'ri-alert-line',
        link: '/pages/alerts'
    },
    {
        id: 6,
        label: 'menuitems.pages.list.informationpages',
        icon: 'ri-information-line',
        link: '/pages/information-pages'
    },
    {
        id: 7,
        label: 'menuitems.pages.list.policypages',
        icon: 'ri-pages-line',
        link: '/pages/policy-pages'
    },
    {
        id: 8,
        label: 'menuitems.pages.list.locations',
        icon: 'ri-map-pin-line',
        link: '/pages/locations'
    },
    {
        id: 9,
        label: 'menuitems.pages.list.massupdate',
        icon: 'ri-newspaper-line',
        link: '/pages/mass-update'
    },
    {
        id: 10,
        label: 'menuitems.pages.list.staffavailability',
        icon: 'ri-calendar-2-line',
        link: '/pages/staff-availability'
    },
    {
        id: 11,
        label: 'menuitems.pages.list.createform',
        icon: 'ri-code-s-slash-fill',
        link: '/pages/create-form'
    },
    {
        id: 13,
        label: 'menuitems.pages.list.pages',
        icon: 'ri-newspaper-line',
        link: '/pages/pages'
    }
];

export { menuItems };